// SPDX-FileCopyrightText: 2024 TRUMPF Laser SE
//
// SPDX-License-Identifier: LicenseRef-TRUMPF
import { Role } from 'model/Role';
import { User } from 'model/User';
import { useAppSelector } from 'store/hooks';

export default function useFilteredUsers(users?: User[], roles?: Role[]) {
  const filter = useAppSelector(s => s.uiSettings.filterText)?.toLocaleLowerCase();

  return users?.filter(u => {
    if (!filter) return true;
    // Match combined name too - the list shows "firstName lastName" as one string.
    const fullName = `${u.firstName ?? ''} ${u.lastName ?? ''}`.toLocaleLowerCase();
    return (
      u.userName?.toLocaleLowerCase()?.includes(filter) ||
      fullName.includes(filter) ||
      u.email?.toLocaleLowerCase()?.includes(filter) ||
      u.roles?.some(roleId =>
        roles
          ?.find(role => role.id === roleId)
          ?.name?.toLocaleLowerCase()
          ?.includes(filter)
      )
    );
  });
}
